import animateScrollTo from 'animated-scroll-to';
import * as Immutable from 'immutable';
import * as React from 'react';
import { Item as MenuItem, ItemParams, Menu as ContextMenu } from 'react-contexify';
import 'react-contexify/dist/ReactContexify.css';
import { injectIntl, WrappedComponentProps as InjectedIntlProps } from 'react-intl';
import ReactPerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Container } from '@edorivai/react-smooth-dnd';
import { compose } from 'redux';
import { Modal } from 'semantic-ui-react';

import EditorChooserPanel from '../../containers/Editor/EditorChooserPanel';
import { localeData } from '../../locales/data';
import { StateType } from '../../reducers';
import { EditorTab as EditorTabType } from '../../reducers/EditorReducer/EditorReducer.types';
import { getIsMonacoInitializedSelector } from '../../reducers/EditorReducer/EditorSelector';
import { TAB_MAX_WIDTH, TAB_MIN_WIDTH } from '../../shared/constants';
import { addModifiers, prefixEditTabMsg } from '../../shared/helpers';
import { isMobile } from '../../shared/helpers/responsive';
import { CloseAlphaProperties } from '../AlphaProperties/CloseAlphaProperties/CloseAlphaProperties';

import { EditorNewTab, EditorTab } from './';
import { EditorMainProps, EditorMainStateProps } from './types';
import './Editor.scss';
import { EditorCloseTabModal } from './EditorCloseTabModal/EditorCloseTabModal';
import EditorIntro from './EditorIntro';
import { EditorMainIfHasTabs } from './EditorMainIfHasTabs';
import { ListEditorTab } from './ListEditorTab';
import { TabsDropdownMenu } from './TabsDropdownMenu';
import { FormattedMessageHelper } from '../../shared/helpers/internationalization';
import {
  getIsCustomPreferencesFetching,
  getIsSimulationWalkthroughComplete,
} from '../../reducers/CustomPreferencesReducer/CustomPreferencesSelectors';
import analytics from '../../shared/services/analytics/analytics';

interface ContextMenuProps {
  handleEnableRename: (params: ItemParams) => void;
  handleSimulateContextMenu: (params: ItemParams) => void;
  duplicateAlpha: (params: ItemParams) => void;
  changeColor?: (params: ItemParams) => void;
  currentColor?: string;
}

const MENU_TYPE_1 = 'MULTI_1';

const ContextMenuWithOptions = ({
  handleEnableRename,
  handleSimulateContextMenu,
  duplicateAlpha,
  changeColor,
  currentColor,
}: ContextMenuProps) => (
  <ContextMenu id={MENU_TYPE_1} animation={false}>
    <MenuItem onClick={handleEnableRename} data={{ action: 'Rename' }}>
      <FormattedMessageHelper
        tagName="span"
        id="editorMain.contextMenuWithOptions.rename"
        defaultMessage={localeData.en['editorMain.contextMenuWithOptions.rename']}
      />
    </MenuItem>
    <MenuItem onClick={duplicateAlpha} data={{ action: 'DuplicateAlphaTab' }}>
      <FormattedMessageHelper
        tagName="span"
        id="editorMain.contextMenuWithOptions.duplicateAlpha"
        defaultMessage={localeData.en['editorMain.contextMenuWithOptions.duplicateAlpha']}
      />
    </MenuItem>
    <MenuItem onClick={handleSimulateContextMenu} data={{ action: 'SimulateAlpha' }}>
      <FormattedMessageHelper
        tagName="span"
        id="editorMain.contextMenuWithOptions.simulateAlpha"
        defaultMessage={localeData.en['editorMain.contextMenuWithOptions.simulateAlpha']}
      />
    </MenuItem>
    <MenuItem onClick={changeColor} data={{ color: 'none' }}>
      <div className={addModifiers('contextMenu__item-no-color', currentColor === null ? ['active'] : [])}>
        <div className="contextMenu__item-no-color-line1" />
        <div className="contextMenu__item-no-color-line2" />
      </div>
      <FormattedMessageHelper
        tagName="span"
        id="editorMain.contextMenuWithOptions.noColor"
        defaultMessage={localeData.en['editorMain.contextMenuWithOptions.noColor']}
      />
    </MenuItem>
    <MenuItem onClick={changeColor} data={{ color: 'RED' }}>
      <div className={addModifiers('contextMenu__item-red contextMenu__item-color', currentColor === 'RED' ? ['active'] : [])}>
        <div className="contextMenu__item-color-line1" />
        <div className="contextMenu__item-color-line2" />
      </div>
      <FormattedMessageHelper
        tagName="span"
        id="editorMain.contextMenuWithOptions.red"
        defaultMessage={localeData.en['editorMain.contextMenuWithOptions.red']}
      />
    </MenuItem>
    <MenuItem onClick={changeColor} data={{ color: 'YELLOW' }}>
      <div className={addModifiers('contextMenu__item-yellow contextMenu__item-color', currentColor === 'YELLOW' ? ['active'] : [])}>
        <div className="contextMenu__item-color-line1" />
        <div className="contextMenu__item-color-line2" />
      </div>
      <FormattedMessageHelper
        tagName="span"
        id="editorMain.contextMenuWithOptions.yellow"
        defaultMessage={localeData.en['editorMain.contextMenuWithOptions.yellow']}
      />
    </MenuItem>
    <MenuItem onClick={changeColor} data={{ color: 'GREEN' }}>
      <div className={addModifiers('contextMenu__item-green contextMenu__item-color', currentColor === 'GREEN' ? ['active'] : [])}>
        <div className="contextMenu__item-color-line1" />
        <div className="contextMenu__item-color-line2" />
      </div>
      <FormattedMessageHelper
        tagName="span"
        id="editorMain.contextMenuWithOptions.green"
        defaultMessage={localeData.en['editorMain.contextMenuWithOptions.green']}
      />
    </MenuItem>
    <MenuItem onClick={changeColor} data={{ color: 'BLUE' }}>
      <div className={addModifiers('contextMenu__item-blue contextMenu__item-color', currentColor === 'BLUE' ? ['active'] : [])}>
        <div className="contextMenu__item-color-line1" />
        <div className="contextMenu__item-color-line2" />
      </div>
      <FormattedMessageHelper
        tagName="span"
        id="editorMain.contextMenuWithOptions.blue"
        defaultMessage={localeData.en['editorMain.contextMenuWithOptions.blue']}
      />
    </MenuItem>
    <MenuItem onClick={changeColor} data={{ color: 'PURPLE' }}>
      <div className={addModifiers('contextMenu__item-purple contextMenu__item-color', currentColor === 'PURPLE' ? ['active'] : [])}>
        <div className="contextMenu__item-color-line1" />
        <div className="contextMenu__item-color-line2" />
      </div>
      <FormattedMessageHelper
        tagName="span"
        id="editorMain.contextMenuWithOptions.purple"
        defaultMessage={localeData.en['editorMain.contextMenuWithOptions.purple']}
      />
    </MenuItem>
  </ContextMenu>
);

const MENU_TYPE_2 = 'MULTI_2';

const ContextMenuWithoutAlpha = ({ handleEnableRename, handleSimulateContextMenu, duplicateAlpha }: ContextMenuProps) => (
  <ContextMenu id={MENU_TYPE_2} animation={false}>
    <MenuItem onClick={handleEnableRename} data={{ action: 'Rename' }}>
      <FormattedMessageHelper
        tagName="span"
        id="editorMain.contextMenuWithOptions.rename"
        defaultMessage={localeData.en['editorMain.contextMenuWithOptions.rename']}
      />
    </MenuItem>
    <MenuItem onClick={duplicateAlpha} data={{ action: 'DuplicateAlphaTab' }}>
      <FormattedMessageHelper
        tagName="span"
        id="editorMain.contextMenuWithOptions.duplicateAlpha"
        defaultMessage={localeData.en['editorMain.contextMenuWithOptions.duplicateAlpha']}
      />
    </MenuItem>
    <MenuItem onClick={handleSimulateContextMenu} data={{ action: 'SimulateAlpha' }}>
      <FormattedMessageHelper
        tagName="span"
        id="editorMain.contextMenuWithOptions.simulateAlpha"
        defaultMessage={localeData.en['editorMain.contextMenuWithOptions.simulateAlpha']}
      />
    </MenuItem>
  </ContextMenu>
);

interface EditorMainState {
  enabledIntro: boolean;
  showMenu: boolean;
  tabMinWidth: number;
  childTabMinWidth: number;
  scrolling: boolean;
  isMobile: boolean;
}

const LEFT: boolean = true;
const RIGHT: boolean = false;

type EditorMainPropsGeneric = EditorMainProps & EditorMainStateProps & InjectedIntlProps;

export class EditorMainIntl extends React.Component<EditorMainPropsGeneric, EditorMainState> {
  state = {
    enabledIntro: false,
    showMenu: false,
    tabMinWidth: TAB_MAX_WIDTH,
    childTabMinWidth: TAB_MAX_WIDTH,
    scrolling: false,
    isMobile: false,
  };

  private tabsScrollRef: any;
  private multiTabScrollRef: any;
  private tabDropdownMenu: any = null;
  private intervalScroll: any = null;
  private handleScrollParent: any = null;
  private handleScrollChild: any = null;

  componentDidMount() {
    if (!this.props.isCustomPreferencesFetching && !this.props.isSimulationWalkthroughComplete && this.props.userId) {
      this.setState({ enabledIntro: true });
    }
    this.setState({ isMobile: isMobile('mobile') });
    this.updateTabsMinWidth();
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('mousedown', this.handleWindowClick, false);
    // Scroll to active tab when tab is hidden because of overflow
    let activeTabElement = this.getActiveTabElement();
    if (activeTabElement) {
      this.scrollToActiveTab(activeTabElement, this.tabsScrollRef);
    }
    if (this.props.tabs.getIn([this.props.currentActiveTab, 'childTabs']) && this.multiTabScrollRef) {
      // Scroll to active child tab when tab is hidden because of overflow
      activeTabElement = document.querySelector('.editor-tabs__child-tab-element--active');
      if (activeTabElement) {
        this.scrollToActiveTab(activeTabElement, this.multiTabScrollRef);
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('mousedown', this.handleWindowClick, false);
  }

  componentDidUpdate(prevProps: EditorMainPropsGeneric & InjectedIntlProps) {
    if (prevProps.tabs.size < this.props.tabs.size && this.tabsScrollRef) {
      // Scroll to new tab
      this.scrollToNewTab(prevProps.tabs.size * TAB_MIN_WIDTH + TAB_MAX_WIDTH, this.tabsScrollRef);
    } else if (prevProps.currentActiveTab !== this.props.currentActiveTab) {
      // Scroll to active tab when tab is hidden because of overflow
      const activeTabElement = this.getActiveTabElement();
      if (activeTabElement) {
        this.scrollToActiveTab(activeTabElement, this.tabsScrollRef);
      }
    } else if (
      prevProps.tabs.getIn([this.props.currentActiveTab, 'childTabs']) &&
      this.props.tabs.getIn([this.props.currentActiveTab, 'childTabs']) &&
      this.multiTabScrollRef
    ) {
      // Scroll actions in child tabs
      const prevChildTabs = prevProps.tabs.getIn([this.props.currentActiveTab, 'childTabs']);
      const nextChildTabs = this.props.tabs.getIn([this.props.currentActiveTab, 'childTabs']);
      const prevActiveChildTabs = prevProps.tabs.getIn([this.props.currentActiveTab, 'activeChildTab']);
      const nextActiveChildTabs = this.props.tabs.getIn([this.props.currentActiveTab, 'activeChildTab']);
      if (prevChildTabs.size < nextChildTabs.size) {
        // Scroll to new child tab
        this.scrollToNewTab(prevChildTabs.size * TAB_MIN_WIDTH + TAB_MAX_WIDTH, this.multiTabScrollRef);
      } else if (prevActiveChildTabs !== nextActiveChildTabs) {
        // Scroll to active child tab when tab is hidden because of overflow
        const activeTabElement: any = document.querySelector('.editor-tabs__child-tab-element--active');
        if (activeTabElement) {
          this.scrollToActiveTab(activeTabElement, this.multiTabScrollRef);
        }
      }
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps: EditorMainPropsGeneric & InjectedIntlProps) {
    const { userId } = this.props;

    // Preferences are hydrated synchronously before `userId` arrives, so gating the intro on the
    // userId transition is enough — the preference data is already settled by then.
    const userIdArrived = !!nextProps.userId && nextProps.userId !== userId;

    if (userIdArrived && !nextProps.isCustomPreferencesFetching && !nextProps.isSimulationWalkthroughComplete) {
      this.setState({ enabledIntro: true });
    }
  }

  getActiveTabElement = () => {
    const activeTabTypes = [
      'editor-tabs__multi-tab-element--active',
      'editor-tabs__super-alpha-tab-element--active',
      'editor-tabs__tab-element--active',
    ];
    let activeTabElement;
    let activeTabType: string;
    for (activeTabType of activeTabTypes) {
      activeTabElement = document.querySelector(`.${activeTabType}`);
      if (activeTabElement) {
        return activeTabElement;
      }
    }

    return null;
  };

  checkIfTabHasIssue = (currentTab: EditorTabType, flashMessages?: Immutable.Map<string, any>, type: string = 'error'): boolean => {
    const messages = flashMessages ? flashMessages.get(`${prefixEditTabMsg}${currentTab.get('id')}`) : null;
    if (currentTab.get('childTabs') && flashMessages) {
      let childTabsHaveErrorsMsgs = false;

      currentTab.get('childTabs').forEach((childTab: any) => {
        const childMessages = flashMessages.get(`${prefixEditTabMsg}${childTab.get('id')}`);
        const filteredMessages = childMessages && childMessages.filter((message: any) => message.getIn(['options', 'type']) === type);
        if (filteredMessages && filteredMessages.size > 0) {
          childTabsHaveErrorsMsgs = true;
        }
      });

      return (messages && messages.size > 0) || childTabsHaveErrorsMsgs ? true : false;
    } else {
      const filteredMessages = messages && messages.filter((message: any) => message.getIn(['options', 'type']) === type);

      return filteredMessages && filteredMessages.size > 0 ? true : false;
    }
  };

  checkIfTabHasAlpha = (currentTab: EditorTabType, currentIndex: number, currentParentTab: number = this.props.currentActiveTab) => {
    if (currentTab.get('childTabs')) {
      return (
        this.props.simulationAlphas.getIn([currentIndex, 'children']) &&
        this.props.simulationAlphas.getIn([currentIndex, 'children']).find((tab: any) => tab.get('alpha'))
      );
    } else if (currentTab.getIn(['settings', 'language', 'value'])) {
      return this.props.simulationAlphas.getIn([currentIndex, 'alpha']);
    } else {
      return this.props.simulationAlphas.getIn([currentParentTab, 'children', currentIndex, 'alpha']);
    }
  };

  handleResize = () => {
    this.updateTabsMinWidth();
    this.setState({ isMobile: isMobile('mobile') });
  };

  handleCreateNewTabTop = () => {
    this.props.handleCreateNewTab();
  };

  handleTabsScrollRef = (ref: any) => {
    this.tabsScrollRef = ref;
  };

  handleMultiTabScrollRef = (ref: any) => {
    this.multiTabScrollRef = ref;
  };

  handleTabDropdownMenu = (ref: any) => {
    this.tabDropdownMenu = ref;
  };

  handleOnExitIntro = () => {
    this.setState({ enabledIntro: false });
  };

  renderIntro() {
    //disable intro on mobile devices, see BRAINTECH-3911
    const isDesktop = window.innerWidth >= 992;
    if (this.props.userSettings && this.state.enabledIntro && this.props.isMonacoInitialized && isDesktop) {
      // @ts-expect-error connect own-props collapse under @types/react@19
      return <EditorIntro handleOnExitIntro={this.handleOnExitIntro} userId={this.props.userId} />;
    } else {
      return null;
    }
  }

  renderNewTab(isChild: boolean, modifiers?: string[]) {
    if (this.props.userSettings) {
      if (isChild === true) {
        const disableButton =
          isChild &&
          this.props.tabs.getIn([this.props.currentActiveTab, 'childTabs']) &&
          this.props.tabs.getIn([this.props.currentActiveTab, 'childTabs']).size >= 10;

        return (
          <EditorNewTab
            isChild={true}
            handleNewTab={this.props.handleCreateNewTab}
            handleNewMultiTab={this.props.handleCreateNewMultiTab}
            handleNewChildTab={this.props.handleCreateNewChildTab}
            hasSuperAlphaPermission={this.props.permissions.includes('SUPER_ALPHA')}
            handleNewSuperAlpha={this.props.handleNewSuperAlpha}
            disable={disableButton}
            modifiers={modifiers}
            numberOfTabs={this.props.tabs.size}
          />
        );
      } else {
        return (
          <EditorNewTab
            isChild={false}
            handleNewTab={this.props.handleCreateNewTab}
            handleNewMultiTab={this.props.handleCreateNewMultiTab}
            hasPermission={this.props.permissions.includes('MULTI_SIMULATION')}
            hasSuperAlphaPermission={this.props.permissions.includes('SUPER_ALPHA')}
            handleNewSuperAlpha={this.props.handleNewSuperAlpha}
            modifiers={modifiers}
            numberOfTabs={this.props.tabs.size}
          />
        );
      }
    } else {
      return null;
    }
  }

  renderModalProperties = (showModal: boolean) => (
    <Modal closeOnDimmerClick={false} closeOnEscape={false} closeIcon={true} open={showModal} onClose={this.props.toggleCloseTabModal}>
      <Modal.Content>
        <CloseAlphaProperties
          handleCancelCloseAlphaProperties={this.props.handleCancelCloseAlphaProperties}
          handleSaveAlphaProperties={this.props.handleSaveAlphaProperties}
          handleNotSaveCloseAlphaProperties={this.props.handleNotSaveCloseAlphaProperties}
        />
      </Modal.Content>
    </Modal>
  );

  renderModal = (modalType: string, showModal: boolean) => (
    <Modal
      closeOnDimmerClick={false}
      closeOnEscape={false}
      closeIcon={true}
      open={showModal}
      size="tiny"
      onClose={modalType === 'closeTabModal' ? this.props.handleCancelModalCloseTab : this.props.handleCancelModalChangeCode}
    >
      <Modal.Content>
        <EditorCloseTabModal
          modalType={modalType}
          handleCancelModalCloseTab={
            modalType === 'closeTabModal' ? this.props.handleCancelModalCloseTab : this.props.handleCancelModalChangeCode
          }
          handleModalCloseTab={modalType === 'closeTabModal' ? this.props.handleModalCloseTab : this.props.handleModalChangeCode}
        />
      </Modal.Content>
    </Modal>
  );

  renderContextMenus = () => (
    <React.Fragment>
      <ContextMenuWithOptions
        handleEnableRename={this.props.handleEnableRename}
        handleSimulateContextMenu={this.props.handleSimulateContextMenu}
        duplicateAlpha={this.props.duplicateAlpha}
        changeColor={this.props.changeColor}
        currentColor={this.props.data && this.props.data.get('color')}
      />
      <ContextMenuWithoutAlpha
        handleEnableRename={this.props.handleEnableRename}
        handleSimulateContextMenu={this.props.handleSimulateContextMenu}
        duplicateAlpha={this.props.duplicateAlpha}
      />
    </React.Fragment>
  );

  renderScrollArrow = (isLeft: boolean, isChild: boolean = false) => {
    let scroll;
    if (!isChild) {
      scroll = isLeft ? this.scrollLeft : this.scrollRight;
    } else {
      scroll = isLeft ? this.scrollChildrenLeft : this.scrollChildrenRight;
    }

    return (
      <div
        className={`editor-tabs__arrow${isChild ? ' editor-tabs__arrow--multi-simulation-children' : ''}`}
        onClick={!this.state.scrolling ? scroll : undefined}
      >
        <span className={`editor-tabs__${isLeft ? 'left' : 'right'}-arrow`} />
      </div>
    );
  };

  renderTabDropdownMenu = () => (
    <div ref={this.handleTabDropdownMenu} className="editor-tabs__dropdown-menu">
      <div className="editor-tabs__dropdown-button" onClick={this.handleDropdown}>
        <span className="editor-tabs__dropdown-button__arrow" />
      </div>
      {this.state.showMenu && (
        <TabsDropdownMenu
          currentTabs={this.props.tabs}
          handleCloseTab={this.props.handleCloseTab}
          handleCloseChildTab={this.props.handleCloseChildTab}
          handleSetTabAsActive={this.props.handleSetTabAsActive}
          handleSetChildTabAsActive={this.props.handleSetChildTabAsActive}
          currentActiveTab={this.props.currentActiveTab}
          progress={this.props.progress}
          calculateProgress={true}
          handleRenameTab={this.props.handleRenameTab}
          handleDisableRename={this.props.handleDisableRename}
          canRename={this.props.canRename}
          renameInfo={this.props.renameInfo}
          isChild={false}
          tabsStatus={this.props.tabsStatus}
          simulationAlphas={this.props.simulationAlphas}
          showMenu={this.state.showMenu}
          handleDropdown={this.handleDropdown}
          handleDropdownMenuClose={this.handleDropdownMenuClose}
          intl={this.props.intl}
          checkIfTabHasIssue={this.checkIfTabHasIssue}
          checkIfTabHasAlpha={this.checkIfTabHasAlpha}
        />
      )}
    </div>
  );

  handleWindowClick = (event: any) => {
    if (this.tabDropdownMenu.contains(event.target)) {
      return;
    }
    this.handleDropdownMenuClose();
  };

  handlerOnCloseClick = (event: React.SyntheticEvent<HTMLSpanElement>) => {
    event.stopPropagation();
    this.props.handleCloseTab(this.props.currentActiveTab);
    this.updateTabMinWidth();
  };

  handleDropdown = () => {
    // Track only when opening the dropdown, not on close, to avoid double-firing.
    if (!this.state.showMenu) {
      analytics.trackCustomEvent('sim_click_tabs_dropdown');
    }
    this.setState(state => ({ showMenu: !state.showMenu }));
  };

  handleDropdownMenuClose = () => {
    this.setState({ showMenu: false });
  };

  scrollLeft = () => {
    if (!this.state.scrolling) {
      this.scroll(-this.tabsScrollRef.offsetWidth / 2, { tabsScroll: this.tabsScrollRef });
    }
  };

  scrollRight = () => {
    if (!this.state.scrolling) {
      this.scroll(this.tabsScrollRef.offsetWidth / 2, { tabsScroll: this.tabsScrollRef });
    }
  };

  scrollChildrenLeft = () => {
    if (!this.state.scrolling) {
      this.scroll(-this.multiTabScrollRef.offsetWidth / 2, { tabsScroll: this.multiTabScrollRef });
    }
  };

  scrollChildrenRight = () => {
    if (!this.state.scrolling) {
      this.scroll(this.multiTabScrollRef.offsetWidth / 2, { tabsScroll: this.multiTabScrollRef });
    }
  };

  scroll = (change: number, { tabsScroll = this.tabsScrollRef, duration = 500 }) => {
    if (!this.state.scrolling && tabsScroll) {
      this.setState({ scrolling: true });
      const start = tabsScroll.scrollLeft;
      let currentTime = 0;
      const increment = 20;
      const easeInOutQuad = (t: number, b: number, c: number, d: number) => {
        t /= d / 2;
        if (t < 1) {
          return (c / 2) * t * t + b;
        }
        t -= 1;

        return (-c / 2) * (t * (t - 2) - 1) + b;
      };
      const animateScroll = () => {
        currentTime += increment;
        const val = easeInOutQuad(currentTime, start, change, duration);
        tabsScroll.scrollLeft = val;
        if (currentTime < duration) {
          setTimeout(animateScroll, increment);
        } else {
          this.setState({ scrolling: false });
        }
      };
      animateScroll();
    }
  };

  scrollToNewTab = (position: number, tabsScrollRef: any) => {
    animateScrollTo(position, { element: tabsScrollRef, horizontal: true });
  };

  scrollToActiveTab = (activeTabElement: any, tabsScrollRef: any) => {
    const tabsActiveBounding = activeTabElement.getBoundingClientRect();
    if (tabsActiveBounding && tabsActiveBounding.left < 0) {
      this.scroll(tabsActiveBounding.left - 60, { tabsScroll: tabsScrollRef, duration: 250 });
    } else if (tabsActiveBounding && tabsScrollRef && tabsActiveBounding.right > tabsScrollRef.offsetWidth) {
      this.scroll(tabsActiveBounding.right - tabsScrollRef.offsetWidth, { tabsScroll: tabsScrollRef, duration: 250 });
    }
  };

  updateTabsMinWidth = () => {
    this.updateTabMinWidth();
    if (this.props.tabs.getIn([this.props.currentActiveTab, 'childTabs'])) {
      this.updateChildTabMinWidth();
    }
  };

  updateTabMinWidth = () => {
    const tabsWrapperElement: any = document.querySelectorAll('.editor-tabs__wrapper')[0];
    const newTab: any = document.querySelectorAll('.editor-tabs__new-tab-element')[0];
    let activeTabElement: any = document.querySelectorAll('.editor-tabs__tab-element--active')[0];
    if (!activeTabElement) {
      activeTabElement = document.querySelectorAll('.editor-tabs__super-alpha-tab-element--active')[0];
    }
    if (!activeTabElement) {
      activeTabElement = document.querySelectorAll('.editor-tabs__multi-tab-element--active')[0];
    }
    const tabsArrows: any = document.querySelectorAll('.editor-tabs__arrow')[0];
    if (this.props.tabs.size > 1 && tabsWrapperElement && newTab && activeTabElement) {
      let tabsHeaderSize =
        Math.ceil(tabsWrapperElement.offsetWidth) + Math.ceil(newTab.offsetWidth) - 42 - Math.ceil(activeTabElement.offsetWidth);
      if (tabsArrows && tabsHeaderSize / (this.props.tabs.size - 1) < TAB_MIN_WIDTH) {
        tabsHeaderSize -= Math.ceil(tabsArrows.offsetWidth) * 2;
      }
      const tabMinWidth = tabsHeaderSize / (this.props.tabs.size - 1);
      this.setState({ tabMinWidth: tabMinWidth < TAB_MAX_WIDTH ? tabMinWidth : TAB_MAX_WIDTH });
    }
  };

  updateChildTabMinWidth = () => {
    const tabsWrapperElement: any = document.querySelectorAll('.editor-tabs__wrapper--multi-simulation-children')[0];
    const newTab: any = document.querySelectorAll('.editor-tabs__new-tab-element--multi-sim-children')[0];
    const activeTabElement: any = document.querySelectorAll('.editor-tabs__child-tab-element--active')[0];
    const tabsArrows: any = document.querySelectorAll('.editor-tabs__arrow--multi-simulation-children')[0];
    if (this.props.tabs.getIn([this.props.currentActiveTab, 'childTabs']).size > 1 && tabsWrapperElement && newTab && activeTabElement) {
      let tabsHeaderSize =
        Math.ceil(tabsWrapperElement.offsetWidth) + Math.ceil(newTab.offsetWidth) - 42 - Math.ceil(activeTabElement.offsetWidth);
      if (tabsArrows) {
        tabsHeaderSize -= Math.ceil(tabsArrows.offsetWidth) * 2;
      }
      const tabMinWidth = Math.floor(tabsHeaderSize / (this.props.tabs.getIn([this.props.currentActiveTab, 'childTabs']).size - 1));
      this.setState({
        childTabMinWidth: tabMinWidth < TAB_MAX_WIDTH ? tabMinWidth : TAB_MAX_WIDTH,
      });
    }
  };

  scrollToPosition = (element: Element, difference: number, goLeft: boolean = true) => {
    const scrollLeft = element.scrollLeft;
    if (goLeft) {
      element.scrollTo(scrollLeft - 1, 0);
    } else {
      element.scrollTo(scrollLeft + 1, 0);
    }
  };

  handleScrollContainer = (queryToSelect: string) => (e: any) => {
    const editorTabs = document.querySelector(queryToSelect);
    clearInterval(this.intervalScroll);
    if (editorTabs) {
      const offsetsFromTabs = editorTabs.getBoundingClientRect();
      const leftDifference = e.clientX - offsetsFromTabs.left;
      const rightDifference = offsetsFromTabs.right - e.clientX;
      const topDifference = e.clientY - offsetsFromTabs.top;
      const bottomDifference = offsetsFromTabs.bottom - e.clientY;
      if (topDifference >= 0 && bottomDifference >= 0) {
        if (leftDifference <= 10) {
          this.intervalScroll = setInterval(() => this.scrollToPosition(editorTabs, leftDifference));
        } else if (rightDifference <= 10) {
          this.intervalScroll = setInterval(() => this.scrollToPosition(editorTabs, rightDifference, false));
        }
      }
    }
  };

  onDragEnd = () => {
    clearInterval(this.intervalScroll);
    document.removeEventListener('mousemove', this.handleScrollChild);
    document.removeEventListener('mousemove', this.handleScrollParent);
    this.props.dispatchStopChangingTabPosition();
  };

  onDrop = (result: any) => {
    clearInterval(this.intervalScroll);
    document.removeEventListener('mousemove', this.handleScrollChild);
    document.removeEventListener('mousemove', this.handleScrollParent);
    this.props.handleChangeTabPosition(result.removedIndex, result.addedIndex);
    this.props.dispatchStopChangingTabPosition();
  };

  onDropChild = (result: any) => {
    document.removeEventListener('mousemove', this.handleScrollChild);
    document.removeEventListener('mousemove', this.handleScrollParent);
    this.props.handleChangeTabPositionChild(this.props.currentActiveTab, result.removedIndex, result.addedIndex);
    this.props.dispatchStopChangingTabPosition();
  };

  onDragStart = () => {
    if (this.handleScrollParent !== null) {
      document.removeEventListener('mousemove', this.handleScrollParent);
    }
    this.handleScrollParent = this.handleScrollContainer('.editor-tabs__parent');
    document.addEventListener('mousemove', this.handleScrollParent);
    this.props.dispatchChangingTabPosition();
  };

  onDragStartChild = () => {
    if (this.handleScrollChild !== null) {
      document.removeEventListener('mousemove', this.handleScrollChild);
    }
    this.handleScrollChild = this.handleScrollContainer('.editor-tabs__wrapper--multi-simulation-children');
    document.addEventListener('mousemove', this.handleScrollChild);
    this.props.dispatchChangingTabPosition();
  };

  render() {
    const activeTab = this.props.tabs.get(this.props.currentActiveTab);
    const tabMinWidth = this.state.tabMinWidth;
    const overflowed = tabMinWidth && tabMinWidth > 0 ? tabMinWidth < 110 : false;
    const childTabMinWidth = this.state.childTabMinWidth;
    const childTabsOverflowed = childTabMinWidth && childTabMinWidth < 110;

    return (
      <div className="editor">
        {this.renderContextMenus()}
        <div className="editor-close-tab__hide">
          {this.renderModal('closeTabModal', this.props.showCloseTabModal)}
          {this.renderModal('changeCodeModal', this.props.showChangeCodeModal)}
          {this.renderModalProperties(this.props.showCloseTabModal !== true && this.props.showPropertiesTabModal)}
        </div>
        <div className="editor-tabs">
          {this.state.isMobile && activeTab && (
            <EditorTab
              multi={activeTab.get('childTabs')}
              isSuperAlpha={activeTab.get('superAlpha')}
              active={true}
              tabName={activeTab.get('tabName')}
              onCloseClickHandler={this.handlerOnCloseClick}
              progress={this.props.progress.getIn([this.props.currentActiveTab, 'percentageProgress'])}
              currentIndex={this.props.currentActiveTab}
              isChild={false}
              canRename={false}
              // @ts-expect-error ImmutableJS getIn returns unknown
              tabStatus={this.props.tabsStatus.getIn([this.props.currentActiveTab, 'parentTab', 'currentStatus'])}
              hasAlpha={this.checkIfTabHasAlpha(activeTab, this.props.currentActiveTab)}
              intl={this.props.intl}
            />
          )}
          {overflowed && !this.state.isMobile && this.renderScrollArrow(LEFT)}
          <ReactPerfectScrollbar
            containerRef={this.handleTabsScrollRef}
            className="editor-tabs editor-tabs__wrapper editor-tabs__parent"
            options={{ suppressScrollY: true }}
          >
            {/* @ts-expect-error react-smooth-dnd Container props not in @types/react@19 */}
            <Container
              onDragStart={this.onDragStart}
              lockAxis="x"
              onDrop={this.onDrop}
              onDragEnd={this.onDragEnd}
              orientation="horizontal"
              key={this.props.tabs && this.props.tabs.size}
            >
              <ListEditorTab
                currentTabs={this.props.tabs}
                handleCloseTab={this.props.handleCloseTab}
                handleSetTabAsActive={this.props.handleSetTabAsActive}
                currentActiveTab={this.props.currentActiveTab}
                progress={this.props.progress}
                calculateProgress={true}
                handleRenameTab={this.props.handleRenameTab}
                handleDisableRename={this.props.handleDisableRename}
                canRename={this.props.canRename}
                renameInfo={this.props.renameInfo}
                isChild={false}
                simulationAlphas={this.props.simulationAlphas}
                handleDropdownMenuClose={this.handleDropdownMenuClose}
                tabsWidth={this.state.tabMinWidth}
                updateTabWidth={this.updateTabMinWidth}
                tabsStatus={this.props.tabsStatus}
                intl={this.props.intl}
                checkIfTabHasIssue={this.checkIfTabHasIssue}
                checkIfTabHasAlpha={this.checkIfTabHasAlpha}
                changeSimulationStatus={this.props.changeSimulationStatus}
              />
            </Container>
          </ReactPerfectScrollbar>
          {overflowed && !this.state.isMobile && this.renderScrollArrow(RIGHT)}
          {this.renderNewTab(false)}
          {this.renderTabDropdownMenu()}
          <EditorChooserPanel />
        </div>
        {this.props.tabs && this.props.tabs.size > 0 && this.props.tabs.getIn([this.props.currentActiveTab, 'childTabs']) && (
          <div id="editor-child-tabs" className="editor-child-tabs">
            {childTabsOverflowed && !this.state.isMobile && this.renderScrollArrow(LEFT, true)}
            <ReactPerfectScrollbar
              containerRef={this.handleMultiTabScrollRef}
              className="editor-tabs editor-tabs__wrapper--multi-simulation-children"
              options={{ suppressScrollY: true }}
            >
              {/* @ts-expect-error react-smooth-dnd Container props not in @types/react@19 */}
              <Container
                onDragEnd={this.onDragEnd}
                onDragStart={this.onDragStartChild}
                lockAxis="x"
                onDrop={this.onDropChild}
                orientation="horizontal"
                key={this.props.tabs.getIn([this.props.currentActiveTab, 'childTabs']).size}
              >
                <ListEditorTab
                  currentTabs={this.props.currentMultiTabs}
                  handleCloseTab={this.props.handleCloseChildTab}
                  handleSetTabAsActive={this.props.handleSetChildTabAsActive}
                  currentActiveTab={this.props.currentChildActiveTab}
                  progress={0}
                  calculateProgress={false}
                  handleRenameTab={this.props.handleRenameTab}
                  handleDisableRename={this.props.handleDisableRename}
                  canRename={this.props.canRename}
                  renameInfo={this.props.renameInfo}
                  isChild={true}
                  parentTabIndex={this.props.currentActiveTab}
                  simulationAlphas={this.props.simulationAlphas}
                  currentParentTab={this.props.currentActiveTab}
                  tabsWidth={this.state.childTabMinWidth}
                  updateTabWidth={this.updateChildTabMinWidth}
                  tabsStatus={this.props.tabsStatus}
                  intl={this.props.intl}
                  checkIfTabHasIssue={this.checkIfTabHasIssue}
                  checkIfTabHasAlpha={this.checkIfTabHasAlpha}
                  changeSimulationStatus={this.props.changeSimulationStatus}
                />
              </Container>
            </ReactPerfectScrollbar>
            {childTabsOverflowed && !this.state.isMobile && this.renderScrollArrow(RIGHT, true)}
            {this.renderNewTab(true, ['multi-sim-children'])}
          </div>
        )}
        {this.props.tabs && this.props.tabs.size > 0 && (
          <EditorMainIfHasTabs
            {...this.props}
            isConsultant={this.props.permissions.includes('CONSULTANT') || this.props.permissions.includes('RESEARCHER')}
            isVisualization={this.props.permissions.includes('VISUALIZATION')}
            enabledIntro={this.state.enabledIntro}
          />
        )}
        {this.renderIntro()}
      </div>
    );
  }
}

const mapStateToProps = (state: StateType): EditorMainStateProps => ({
  // @ts-expect-error connect own-props collapse under @types/react@19
  isMonacoInitialized: getIsMonacoInitializedSelector(state),
  isSimulationWalkthroughComplete: getIsSimulationWalkthroughComplete(state),
  isCustomPreferencesFetching: getIsCustomPreferencesFetching(state),
});

export const EditorMain = compose<React.ComponentType<EditorMainPropsGeneric>>(
  injectIntl,
  withRouter,
  connect<EditorMainStateProps, any, any, StateType>(mapStateToProps)
)(EditorMainIntl);
